
/* ---------- reviews carousel ----------
   REVIEWS[] is PLACEHOLDER copy, not real customer submissions.
   photo tags: "owner" = real product photo, "generated" = AI render of the packaging.
   Swap both for genuine reviews and genuine customer photos before launch. */
var REVIEWS=[
 {t:"Between the smell, the high, and how fresh the buds were, this was by far my best order yet.",
  n:"Thomas C.", s:5, p:["rev-r1","rev-p1","rev-r2"]},
 {t:"Bag appeal is real. Dense, sticky, and the jar smell hits before you get the lid all the way off.",
  n:"Marcus D.", s:5, p:["rev-p2","rev-r3","rev-r4"]},
 {t:"Third order and it has been consistent every single time. That is the part most places get wrong.",
  n:"Jordan P.", s:5, p:["rev-r5","rev-p3","rev-r6"]},
 {t:"Grinds up beautifully and burns clean to a white ash. Packaging showed up sealed and discreet.",
  n:"Denise R.", s:5, p:["rev-p4","rev-r7","rev-r8"]}
];
if (window.EL_REVIEWS && window.EL_REVIEWS.length) REVIEWS = window.EL_REVIEWS;
(function(){
  var i=0, card=document.querySelector('.quote-card'),
      elT=document.getElementById('qText'), elN=document.getElementById('qName'),
      elS=document.getElementById('qStars'), strip=document.getElementById('revPhotos'),
      dots=document.getElementById('revDots');
  if(!elT||!strip) return;

  function paintPhotos(){
    strip.innerHTML = REVIEWS[i].p.map(function(id){
      return '<div class="rev-photo"><img src="'+EA(id+'.jpg')+'" alt="Customer photo" loading="lazy" decoding="async"></div>';
    }).join('');
  }
  function paint(){
    var r=REVIEWS[i];
    elS.textContent='\u2605'.repeat(r.s);
    elT.textContent=r.t;
    elN.textContent=r.n;
    paintPhotos();
    [].forEach.call(dots.children,function(b,n){ b.classList.toggle('on',n===i); });
  }
  function go(n){
    i=(n+REVIEWS.length)%REVIEWS.length;
    card.classList.add('fade');
    setTimeout(function(){ paint(); card.classList.remove('fade'); },170);
  }
  dots.innerHTML=REVIEWS.map(function(_,n){
    return '<button aria-label="Review '+(n+1)+'"></button>';
  }).join('');
  [].forEach.call(dots.children,function(b,n){ b.addEventListener('click',function(){go(n)}); });
  document.getElementById('revPrev').addEventListener('click',function(){go(i-1)});
  document.getElementById('revNext').addEventListener('click',function(){go(i+1)});

  var sx=null;
  strip.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
  strip.addEventListener('touchend',function(e){
    if(sx===null) return;
    var dx=e.changedTouches[0].clientX-sx;
    if(Math.abs(dx)>48) go(i+(dx<0?1:-1));
    sx=null;
  },{passive:true});

  paint();
})();
